import React from "react";
import "./teams-layout.scss";

interface TeamsPageLayoutProps {
  children: React.ReactNode;
}

const TeamsPageLayout: React.FC<TeamsPageLayoutProps> = ({ children }) => {
  return (
    <div className="bodyWrap">
      <div className="innerpage">
        <div className="container-fluid">
          <div className="row mt-4">
            <div className="col-12">
              <div className="card cardBgNone border-0">
                {children}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TeamsPageLayout;
